import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const ForgotPasswordModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="text-center p-4">
        <h3 className="text-custom-blue fw-bold">Esqueceu sua senha?</h3>
        <p className="text-muted">Entre em contato com o ds@fiemg.com.br</p>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPasswordModal;
